module.exports = __webpack_public_path__ + "static/media/Necrolyte.a04022f9.png";